// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__GP5_i","condensed":"styles_condensed__yt932"};